import { render, staticRenderFns } from "./LabelTagging.vue?vue&type=template&id=099e67e2&"
import script from "./LabelTagging.vue?vue&type=script&lang=js&"
export * from "./LabelTagging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('099e67e2')) {
      api.createRecord('099e67e2', component.options)
    } else {
      api.reload('099e67e2', component.options)
    }
    module.hot.accept("./LabelTagging.vue?vue&type=template&id=099e67e2&", function () {
      api.rerender('099e67e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/labelTagging/LabelTagging.vue"
export default component.exports